import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import { getClinicFacilities } from "../../../redux/reducers/clinicSlice";
import {
  admitPatientByPatientId,
  admitPet,
} from "../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const initValues = {
  kennelNumber: null,
  remark: "",
  vet: null,
  facilityType: "Kennel",
};
const facilitesList = [
  { name: "Kennel", value: "Kennel" },
  { name: "Operation Theatre", value: "OperationTheatre" },
];

const InpatientAdmitPatient = ({
  modalVisible,
  onCloseMod,
  modalData,
  sendToRecovery = false,
}) => {
  const dispatch = useDispatch();
  const [modalVsble, setModalVsble] = useState(false);
  const [admitValues, setAdmitValues] = useState(initValues);
  const [admitErrors, setAdmitErrors] = useState({});
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const { facilities } = useSelector((state) => state?.clinic);
  const reqData = modalData?.appoinment ? modalData?.appoinment : modalData;

  useEffect(() => {
    dispatch(getClinicVets());
    dispatch(getClinicFacilities());
  }, []);

  useEffect(() => {
    setModalVsble(modalVisible);
  }, [modalVisible]);

  const onCloseAdmitModal = () => {
    setModalVsble(false);
    setAdmitValues(initValues);
    setAdmitErrors({});
    onCloseMod();
  };

  const handleAdmitChange = (name, value) => {
    const reqValue =
      typeof value === "object" ? value?.value?.toString() : value;
    setAdmitValues({ ...admitValues, [name]: value });
    setAdmitErrors({
      ...admitErrors,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    });
  };

  const getVetList = () => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    return reqVetList ?? [];
  };

  const getKennelList = (typ) => {
    return facilities
      ?.filter(
        (li) => li?.type?.toLowerCase() === typ?.toLowerCase() && li?.status
      )
      ?.map((li) => {
        return { name: li?.name, value: li?.name, id: li?.id };
      });
  };

  const handleAdmitPatient = () => {
    if (
      !admitValues?.kennelNumber ||
      (!sendToRecovery && !admitValues?.vet) ||
      (!sendToRecovery && admitValues?.remark?.length === 0)
    ) {
      return setAdmitErrors({
        ...admitErrors,
        kennelNumber: !admitValues?.kennelNumber
          ? "This field is required"
          : "",
        vet: !admitValues?.vet ? "This field is required" : "",
        remark:
          admitValues?.remark?.length === 0 ? "This field is required" : "",
      });
    }
    const data = {
      appointmentId: reqData?.appointmentId,
      kennelNumber: admitValues?.kennelNumber,
      remark: admitValues?.remark ?? "",
      hospitalization: sendToRecovery ? false : true,
      doctorId: admitValues?.vet?.value ?? reqData?.doctorId,
    };
    if (sendToRecovery) {
      data.facilityType = admitValues?.facilityType ?? "Kennel";
    }
    dispatch(
      reqData?.patientId
        ? admitPatientByPatientId({ patientId: reqData?.patientId, data })
        : admitPet({
            petId: reqData?.petId,
            vetId: admitValues?.vet?.value,
            data,
            url: `?appointmentStatus=recovery`,
          })
    ).then((res) => {
      if (res?.payload) {
        onCloseMod("Api Success");
        onCloseAdmitModal();
      }
    });
  };

  return (
    <>
      <CustomModal
        open={modalVsble}
        onClose={onCloseAdmitModal}
        header="Admit Patient"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12}>
            <Card sx={cardSty} className="CustomCard-back-appointment">
              <div className="maint">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {reqData?.petImage ? (
                        <CardMedia
                          image={reqData?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {reqData?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {reqData?.petName}
                          </div>
                          <Typography
                            className={`ml5 text capitalize ${
                              reqData?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${reqData?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {reqData?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {reqData?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(reqData?.dob).fromNow()} ({reqData?.dob})
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
          {sendToRecovery ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomSelect
                  list={facilitesList}
                  handleChange={(e) =>
                    handleAdmitChange("facilityType", e?.target?.value)
                  }
                  name="facilityType"
                  label="Facility Type *"
                  select
                  value={admitValues?.facilityType}
                  error={!!admitErrors?.facilityType}
                  helperText={admitErrors?.facilityType}
                />
              </div>
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="mb20">
              <CustomSelect
                list={getKennelList(admitValues?.facilityType)}
                handleChange={(e) =>
                  handleAdmitChange("kennelNumber", e?.target?.value)
                }
                name="kennelNumber"
                label={
                  admitValues?.facilityType === "Kennel"
                    ? "Kennel Number *"
                    : "Operation Theatre *"
                }
                select
                value={admitValues?.kennelNumber}
                error={!!admitErrors?.kennelNumber}
                helperText={admitErrors?.kennelNumber}
              />
            </div>
          </Grid>
          {!sendToRecovery ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomTextField
                  fullWidth
                  multiline
                  rows={3}
                  handleChange={(e) =>
                    handleAdmitChange("remark", e?.target?.value)
                  }
                  label="Reason "
                  required={true}
                  value={admitValues?.remark ?? ""}
                  error={!!admitErrors?.remark}
                  helperText={admitErrors?.remark}
                />
              </div>
            </Grid>
          ) : null}

          {!sendToRecovery ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mb20">
                <CustomSelect
                  list={getVetList()}
                  handleChange={(e, value) => handleAdmitChange("vet", value)}
                  name="vet"
                  label="Vet Name *"
                  search
                  value={admitValues?.vet}
                  error={!!admitErrors?.vet}
                  helperText={admitErrors?.vet}
                />
              </div>
            </Grid>
          ) : null}
        </Grid>
        <div className="flex1-end mt20">
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <CustomButton text="Save" onClick={handleAdmitPatient} smallBtn />
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default InpatientAdmitPatient;
